import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'antd';

const SwitchWidget = props => (
  <Switch
    value={props.value}
    checked={typeof props.value === "undefined" ? true : !props.value}
    required={props.required}
    onChange={(value) => { console.log(value); props.onChange(!value); }}
    checkedChildren={'Идэвхтэй'}
    unCheckedChildren={'Идэвхгүй'}
    disabled={props.disabled}
  />
);

SwitchWidget.defaultProps = {
  value: undefined,
  disabled: false,
};

SwitchWidget.propTypes = {
  value: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SwitchWidget;



// WEBPACK FOOTER //
// ./src/components/Form/Widgets/SwitchWidget/index.js